document.addEventListener('submit', (event) => {
  const form = event.target.closest('[data-pagination-goto]');
  if (!form) return;
  event.preventDefault();

  const input = form.querySelector('.pagination-goto__input');
  const total = parseInt(form.dataset.totalPages, 10) || 1;

  let page = parseInt(input.value, 10);
  if (Number.isNaN(page) || page < 1) page = 1;
  if (page > total) page = total;

  input.value = page;

  const url = new URL(window.location.href);
  url.searchParams.set('page', page);

  const anchor = (form.dataset.anchor || '').trim();
  url.hash = anchor.replace(/^#/, '');

  window.location.assign(url.toString());
});